export default __webpack_public_path__ + "static/media/E-Bikebörse.caa2a7e7.png";